export default [
    {
        path: '/value-added-services',
        name: 'valueAddedServicesList',
        component: () => import(/* webpackChunkName: "valueAddedServices" */ '../views/List.vue'),
        props: true,
    },
    {
        path: '/value-added-services/create',
        name: 'valueAddedServicesCreate',
        component: () => import(/* webpackChunkName: "valueAddedServices" */'../views/Form.vue')
    },
    {
        path: '/value-added-services/:id/edit',
        name: 'valueAddedServicesEdit',
        component: () => import(/* webpackChunkName: "valueAddedServices" */'../views/Form.vue')
    },
    {
        path: '/value-added-services/:id/show',
        name: 'valueAddedServicesView',
        component: () => import(/* webpackChunkName: "valueAddedServices" */'../views/View.vue')
    },
]